import React from "react";
import { Button } from "xsolla-uikit";

import { Switch, Route, Link } from "react-router-dom";

export const sites = [
    {
      product: 'site_builder',
      sku: 'login_1',
      name: "My Game: Ultimate Edition",
      id: "mygame.xsollasitebuilder.com",
      img: "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
      status: "active",
      customize: 'widget',
      button: ()=>{return <Link to="/site_builder/my_project">
        <Button
          appearance="outline"
        >
          Edit settings
        </Button>
      </Link>},
      used: [
        {
          product:  'store',
          name: "Game keys / My Game: Ultimate Edition",
          action: "/game_keys/my_project",
          status: 'active',
        },
        {
          product:  'login',
          name: "My Game Login",
          action: "/login/my_project/",
          status: 'draft',
        },
        {
          product: 'launcher',
          name: "My Game Launcher",
          action: "/launcher/my_project/",
          status: 'draft',
        }
      ],
      todo: [
        {
          title: "Complete setting up your landing page",
          value: 0.5
        },
        {
          title: "Sign Licensing Agreement",
          value: 0
        },
        {
          title: "Publish your landing page",
          value: 0
        },
        {
          title: "Set up your own domain",
          value: 0
        },
        {
          title: "Use Partner Network",
          value: 0
        }
      ],
    },
    {
      product: 'site_builder',
      sku: 'login_2',
      name: "test login",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      customize: 'widget',
      img:
        "https://res.cloudinary.com/maiik/image/upload/v1550459635/Xsolla/fundamentals_thumb4_FINAL_002.jpg",
      status: "draft",
      used: [
        {
          name: "Game keys / My Game: Ultimate Edition",
          action: "/game_keys/my_project/"
        }
      ],
      // todo = {[
            //   {
            //     title: "Complete setting up your landing page",
            //     value: 1
            //   },
            //   {
            //     title: "Sign Licensing Agreement",
            //     value: 1
            //   },
            //   {
            //     title: "Publish your landing page",
            //     value: 1
            //   },
            //   {
            //     title: "Set up your own domain",
            //     value: 1
            //   },
            //   {
            //     title: "Use Partner Network",
            //     value: 0
            //   }
            // ]}

    },
  ];